module.exports = __webpack_public_path__ + "pic/53.7bbc342f.png";